import React from 'react';

const Garage = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38.175">
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M-763.5-1075.785h1920v3009h-1920z" />
            <g stroke="currentColor" transform="translate(1.5 1.802)">
                <path
                    strokeWidth="3"
                    d="M7.392 34.839V19.84a4 4 0 0 1 4-4h13.123a4 4 0 0 1 3.14 6.475c.859 8.823.859 12.772.859 12.523"
                />
                <path
                    strokeLinecap="square"
                    strokeWidth="3"
                    d="M26.929 22.705H7.92"
                />
                <circle cx="17.425" cy="8.976" r="1.084" fill="currentColor" />
                <path
                    strokeLinecap="square"
                    strokeWidth="3"
                    d="M26.929 27.985H7.92"
                />
                <path
                    strokeWidth="3"
                    d="M17.577 0C5.859 6.98 0 10.683 0 11.112v19.761a4 4 0 0 0 4 4h26.282a4 4 0 0 0 4-3.853C34.76 18.252 35 12.046 35 12.404 35 12.796 29.192 8.661 17.577 0Z"
                />
            </g>
        </g>
    </svg>
);

export default Garage;
